import React from 'react';
import { statusVariant } from '@/lib/format';
import { cn } from '@/lib/utils';

const classes = {
  paid: 'bg-[hsl(152_60%_34%/0.12)] text-[hsl(152_60%_28%)] border-[hsl(152_60%_34%/0.25)]',
  due: 'bg-[hsl(34_92%_45%/0.12)] text-[hsl(34_85%_36%)] border-[hsl(34_92%_45%/0.25)]',
  overdue: 'bg-[hsl(0_84%_56%/0.10)] text-[hsl(0_75%_48%)] border-[hsl(0_84%_56%/0.25)]',
  draft: 'bg-muted text-muted-foreground border-border',
  active: 'bg-[hsl(var(--role-accent)/0.12)] text-[hsl(var(--role-accent))] border-[hsl(var(--role-accent)/0.25)]',
};

export function StatusPill({ status, label, className }) {
  const variant = statusVariant(status);
  const cls = classes[variant] || classes.draft;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn('inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize', cls, className)}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', variant === 'paid' && 'bg-[hsl(152_60%_34%)]', variant === 'due' && 'bg-[hsl(34_92%_45%)]', variant === 'overdue' && 'bg-[hsl(0_84%_56%)]', variant === 'active' && 'bg-[hsl(var(--role-accent))]', variant === 'draft' && 'bg-muted-foreground')} />
      {(label || status || '').replace('_', ' ')}
    </span>
  );
}
